import { render, staticRenderFns } from "./SearchFilterTokens.vue?vue&type=template&id=726c3b4a&scoped=true&"
import script from "./SearchFilterTokens.vue?vue&type=script&lang=js&"
export * from "./SearchFilterTokens.vue?vue&type=script&lang=js&"
import style0 from "./SearchFilterTokens.vue?vue&type=style&index=0&id=726c3b4a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "726c3b4a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('726c3b4a')) {
      api.createRecord('726c3b4a', component.options)
    } else {
      api.reload('726c3b4a', component.options)
    }
    module.hot.accept("./SearchFilterTokens.vue?vue&type=template&id=726c3b4a&scoped=true&", function () {
      api.rerender('726c3b4a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2cdLaVl8G5woD/JS/comp/SearchFilterTokens.vue"
export default component.exports